import React from 'react';
import { LuTruck, LuSun, LuCrown, LuTrendingUp, LuSiren, LuMail } from 'react-icons/lu';

const COMPANIES = [
  { name: "Paul's Transport",   icon: LuTruck },
  { name: 'SolarExclusive',     icon: LuSun },
  { name: 'The Lead King',      icon: LuCrown },
  { name: 'Best SEO Plans',     icon: LuTrendingUp },
  { name: 'Alliance Ambulance', icon: LuSiren },
  { name: 'Mailbox ROI',        icon: LuMail },
];

export default function HomeLogos() {
  // Duplicated once for a seamless marquee loop.
  const loop = [...COMPANIES, ...COMPANIES];

  return (
    <section className="hl">
      <div className="hl-container">
        <p className="hl-label">Trusted by teams across industries</p>
        <div className="hl-track-wrap">
          <div className="hl-track">
            {loop.map((c, i) => {
              const Icon = c.icon;
              return (
                <div key={i} className="hl-item" aria-label={c.name}>
                  <Icon size={18} strokeWidth={1.75} className="hl-icon" />
                  <span className="hl-name">{c.name}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <style jsx>{`
        .hl {
          background: #ffffff;
          padding: clamp(3rem, 7vh, 5rem) 0;
          font-family: 'Geist', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          overflow: hidden;
          border-top: 1px solid rgba(0,0,0,0.06);
        }
        .hl-container {
          max-width: 1400px;
          margin: 0 auto;
          padding: 0 clamp(1rem, 3vw, 2rem);
        }
        .hl-label {
          text-align: center;
          font-size: 0.8125rem;
          font-weight: 500;
          color: rgba(0,0,0,0.55);
          letter-spacing: -0.005em;
          margin: 0 0 clamp(1.5rem, 3vh, 2.25rem);
        }

        /* Marquee track with edge fades */
        .hl-track-wrap {
          position: relative;
          overflow: hidden;
          mask-image: linear-gradient(to right, transparent 0, #000 12%, #000 88%, transparent 100%);
          -webkit-mask-image: linear-gradient(to right, transparent 0, #000 12%, #000 88%, transparent 100%);
        }
        .hl-track {
          display: flex;
          align-items: center;
          gap: clamp(2.5rem, 5vw, 4.5rem);
          width: max-content;
          animation: hl-scroll 38s linear infinite;
          will-change: transform;
        }
        .hl-track:hover { animation-play-state: paused; }
        @keyframes hl-scroll {
          from { transform: translateX(0); }
          to   { transform: translateX(-50%); }
        }

        .hl-item {
          display: inline-flex;
          align-items: center;
          gap: 0.625rem;
          color: rgba(0,0,0,0.5);
          font-size: 1.0625rem;
          font-weight: 500;
          letter-spacing: -0.015em;
          white-space: nowrap;
          transition: color 200ms ease, filter 200ms ease;
          filter: grayscale(1);
        }
        .hl-item:hover {
          color: #000;
          filter: grayscale(0);
        }
        .hl-icon { color: inherit; flex-shrink: 0; }
        .hl-name { line-height: 1; }

        @media (prefers-reduced-motion: reduce) {
          .hl-track { animation: none; }
        }
        @media (max-width: 640px) {
          .hl-item { font-size: 0.9375rem; }
          .hl-track { gap: 2rem; }
        }
      `}</style>
    </section>
  );
}
